import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse } from '@libs/graphql';
import { WithdrawalAddresses } from '@libs/types';

export type GetWithdrawalAddressesRes = {
  getCryptoWithdrawalAddresses: DefaultApiResponse<WithdrawalAddresses[]>;
};

export const getWithdrawalAddressesQuery: TypedDocumentNode<GetWithdrawalAddressesRes> = gql`
  query GetCryptoWithdrawalAddresses {
    getCryptoWithdrawalAddresses {
      id
      name
      address
      asset {
        name
        code
        iconUrl
      }
      network {
        name
        code
        id
        iconUrl
      }
    }
  }
`;
